module.exports = __webpack_public_path__ + "img/8.67f247b.png";